import { useEffect, useState } from "react";
import { Tabs, Tab, Box, Button } from "@mui/material";
import { styled } from "@mui/system";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import StoreListingPage from "./StoreListing";
import Collaboration from "./Collaboration";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobal } from "../Context/globalContext";

const StyledBox = styled(Box)(({ theme }) => ({
  padding: "16px",
  [theme.breakpoints.down("sm")]: {
    padding: "0",
  },
}));

const ContentBox = styled(Box)({
  marginTop: "16px",
});

const BackButton = styled(Button)(({ theme }) => ({
  // border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.main,
  textTransform: "none",
  marginBottom: "16px",
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    // borderColor: theme.palette.primary.main,
  },
}));

export default function DetailsPage() {
  const { categoriesData, bucketURLS={} } = useGlobal();
  const [tabValue, setTabValue] = useState(0);
  const [showTabs, setShowTabs] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { state } = location;
    if (state?.hd_id) {
      setShowTabs(true);
    } else {
      navigate("/");
    }
  }, []);

  const handleBack = () => {
    navigate(-1); // go back to previous page
  };

  return showTabs ? (
    <StyledBox>
      <BackButton startIcon={<ArrowBackIcon />} onClick={handleBack}>
        Back
      </BackButton>

      <Tabs value={tabValue} onChange={(_, newValue) => setTabValue(newValue)}>
        <Tab label="Package Details" />
        <Tab label="Owners & Collaborators" />
      </Tabs>

      <ContentBox>
        {tabValue === 0 && <StoreListingPage categoriesData={categoriesData} bucketURLS={bucketURLS} />}
        {tabValue === 1 && <Collaboration bucketURLS={bucketURLS} />}
      </ContentBox>
    </StyledBox>
  ) : null;
}
